<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{'show': shallShowUserProfileSidebar || shallShowActiveChatContactSidebar || mqShallShowLeftSidebar}"
      @click="mqShallShowLeftSidebar=shallShowActiveChatContactSidebar=shallShowUserProfileSidebar=false"
    />

    <!-- Main Area -->
    <section class="chat-app-window">

      <!-- Add Article Modal -->
      <b-modal
        v-model="addForumModal"
        hide-footer
        centered
        size="md"
        title="Add A Forum"
      >
        <b-form-group label="Forum Title" label-for="enterTitle">
          <b-form-input
            id="enterTitle"
            placeholder="Enter the Forum's Title"
            v-model="addForumName"
          />
        </b-form-group>

        <b-form-group label="Forum Description" label-for="forumDescription">
          <b-form-textarea
            v-model="addForumDescription"
            placeholder="Enter the description of the forum"
            rows="5"
            :state="addForumDescription.length <= maxChar"
            class="char-textarea"
            :class="addForumDescription.length >= maxChar ? 'text-danger' : ''"
          />
          <small
            class="textarea-counter-value float-right"
            :class="addForumDescription.length >= maxChar ? 'bg-danger' : ''"
          >
            <span class="char-count">{{ addForumDescription.length }}</span> /
            {{ maxChar }}
          </small>
        </b-form-group>

        <b-button variant="outline-primary" @click="storeForum()">
          Submit
        </b-button>
      </b-modal>

      <!-- Start Chat Logo -->
      <div
        v-if="!activeChat.data"
        class="start-chat-area"
      >
        <div class="mb-1 start-chat-icon">
          <feather-icon
            icon="MessageSquareIcon"
            size="56"
          />
        </div>
        <h4
          class="sidebar-toggle start-chat-text"
          @click="startConversation"
        >
          Click to view a Conversation
        </h4>
      </div>

      <!-- Chat Content -->
      <div
        v-else
        class="active-chat"
      >
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">

            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">

              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>
              <h6 class="mb-0 text-truncate" v-for="contact in activeChat.contacts" :key="contact.id">
                {{ contact.first_name }} {{ contact.last_name }},
              </h6>
            </div>
          </header>
        </div>

        <!-- User Chat Area -->
        <vue-perfect-scrollbar
          ref="refChatLogPS"
          :settings="perfectScrollbarSettings"
          class="user-chats scroll-area"
        >
          <forum-log
            :chat-data="activeChat"
            :profile-user-avatar="profileUserDataMinimal.avatar"
          />
        </vue-perfect-scrollbar>

        <!-- Message Input -->
        <b-form
          class="chat-app-form"
          @submit.prevent="sendMessage"
        >
          <b-input-group class="input-group-merge form-send-message mr-1">
            <b-form-input
              v-model="chatInputMessage"
              placeholder="Enter your message"
            />
          </b-input-group>
          <b-button
            variant="primary"
            type="submit"
          >
            Send
          </b-button>
        </b-form>
      </div>
    </section>

    <!-- Active Chat Contact Details Sidebar -->
    <!-- <chat-active-chat-content-details-sidedbar
      :shall-show-active-chat-contact-sidebar.sync="shallShowActiveChatContactSidebar"
      :contact="activeChat.contact || {}"
    /> -->

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <forum-left-sidebar
        :chats-contacts="chatsContacts"
        :contacts="contacts"
        :active-chat-contact-id="activeChat.contact ? activeChat.contact.id : null"
        :shall-show-user-profile-sidebar.sync="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        @show-user-profile="showUserProfileSidebar"
        @open-chat="openChatOfContact"
        @open-add-forum="openAddForumModal"
      />
    </portal>
  </div>
</template>

<script>
import store from '@/store'
import {
  ref, onUnmounted, nextTick,
} from '@vue/composition-api'
import {
  BAvatar, BDropdown, BDropdownItem, BForm, BFormGroup, BInputGroup, BFormInput, BButton, BModal, BFormTextarea
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import { formatDate } from '@core/utils/filter'
import { $themeBreakpoints } from '@themeConfig'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import ForumLeftSidebar from './ForumLeftSidebar.vue'
import chatStoreModule from './chatStoreModule'
import ChatActiveChatContentDetailsSidedbar from './ChatActiveChatContentDetailsSidedbar.vue'
import ForumLog from './ForumLog.vue'
import useChat from './useChat'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export default {
  components: {

    // BSV
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BModal,
    BFormTextarea,
    BButton,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    ForumLeftSidebar,
    ChatActiveChatContentDetailsSidedbar,
    ForumLog,
  },
  setup() {
    const CHAT_APP_STORE_MODULE_NAME = 'app-chat'

    const maxChar = ref(100);

    const addForumModal = ref(false)
    const addForumName = ref('')
    const addForumDescription = ref('')

    // Register module
    if (!store.hasModule(CHAT_APP_STORE_MODULE_NAME)) store.registerModule(CHAT_APP_STORE_MODULE_NAME, chatStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CHAT_APP_STORE_MODULE_NAME)) store.unregisterModule(CHAT_APP_STORE_MODULE_NAME)
    })

    const { resolveAvatarBadgeVariant } = useChat()

    // Scroll to Bottom ChatLog
    const refChatLogPS = ref(null)
    const scrollToBottomInChatLog = () => {
      const scrollEl = refChatLogPS.value.$el || refChatLogPS.value
      scrollEl.scrollTop = scrollEl.scrollHeight
    }

    // ------------------------------------------------
    // Chats & Contacts
    // ------------------------------------------------
    const chatsContacts = ref([])
    const contacts = ref([])

    const fetchChatAndContacts = () => {
      store.dispatch('app-chat/fetchForums')
        .then(response => {
          response.data.data.forEach(item => {
            let participants = []
            participants.push(item)
            if (participants) {
              chatsContacts.value.push(participants)
            }
          })
          
          // eslint-disable-next-line no-use-before-define
          if (response.data.data.length) {
            profileUserDataMinimal.value = response.data.data[0].participants[0].messageable
          }
        })
    }

    fetchChatAndContacts()

    // ------------------------------------------------
    // Single Chat
    // ------------------------------------------------
    const activeChat = ref({})
    const chatInputMessage = ref('')
    const openChatOfContact = conversationId => {
      // Reset send message input value
      chatInputMessage.value = ''

      store.dispatch('app-chat/getChat', { conversationId })
        .then(response => {
          activeChat.value = response.data.data

          // const contact = chatsContacts.value.find(c => c[2].conversation_id === conversationId)
          activeChat.value.user = profileUserData.value
          activeChat.value.contacts = response.data.contacts
          activeChat.value.conversation_id = conversationId

          // Scroll to bottom
          nextTick(() => { scrollToBottomInChatLog() })
        })

      // if SM device =>  Close Chat & Contacts left sidebar
      // eslint-disable-next-line no-use-before-define
      mqShallShowLeftSidebar.value = false
    }

    const sendMessage = () => {
      if (!chatInputMessage.value) return
      const payload = {
        conversation_id: activeChat.value.conversation_id,
        // eslint-disable-next-line no-use-before-define
        message: chatInputMessage.value,
      }
      store.dispatch('app-chat/sendMessage', payload)
        .then(response => {
          activeChat.value.data.push(response.data.data)

          // Reset send message input value
          chatInputMessage.value = ''

          // Scroll to bottom
          nextTick(() => { scrollToBottomInChatLog() })
        })
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    // User Profile Sidebar
    // ? Will contain all details of profile user (e.g. settings, about etc.)
    const profileUserData = ref({})
    // ? Will contain id, name and avatar & status
    const profileUserDataMinimal = ref({})

    const shallShowUserProfileSidebar = ref(false)
    const showUserProfileSidebar = () => {
      store.dispatch('app-chat/getProfileUser')
        .then(response => {
          profileUserData.value = response.data
          
          shallShowUserProfileSidebar.value = true

          const EchoInstance = new Echo({
            broadcaster: 'pusher',
            key: '8asewg.CUajUg',
            wsHost: 'realtime-pusher.ably.io',
            wsPort: 443,
            disableStats: true,
            encrypted: true,
          })
        
          const isEmpty = Object.keys(profileUserData.value).length === 0;
          if (!isEmpty) {
            EchoInstance
              .channel(profileUserData.value.email.toString())
              .listen('.message.new', (data) => {
                const isEmpty = Object.keys(activeChat.value).length === 0;
                if (!isEmpty) {
                  // console.log(activeChat.value)
                  if (activeChat.value.conversation_id == data.message.conversation_id) {
                    activeChat.value.data.push(data.message)
                    scrollToBottomInChatLog()
                  }
                }
              });
          }
        })
    }

    showUserProfileSidebar()

    // Active Chat Contact Details
    const shallShowActiveChatContactSidebar = ref(false)

    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
    const startConversation = () => {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        mqShallShowLeftSidebar.value = true
      }
    }

    const openAddForumModal = () => {
      addForumModal.value = true
    }

    // Use toast
    const toast = useToast()

    const storeForum = () => {
      store.dispatch('app-chat/addForum', {
        'title': addForumName.value,
        'description': addForumDescription.value
      })
      .then(response => {
        let participants = []
        participants.push(response.data.data)
        chatsContacts.value.push(participants)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Forum added successfully',
            icon: 'AlertTriangleIcon',
            variant: 'success',
          },
        })
        addForumModal.value = false
        addForumName.value = ''
        addForumDescription.value = ''
      })
      .catch(error => {
        console.log(error)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching categories list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
    }
    

    return {
      // Filters
      // formatDate,

      // useChat
      resolveAvatarBadgeVariant,

      // Chat & Contacts
      chatsContacts,
      contacts,

      // Single Chat
      refChatLogPS,
      activeChat,
      chatInputMessage,
      openChatOfContact,
      sendMessage,

      // Profile User Minimal Data
      profileUserDataMinimal,

      // User Profile Sidebar
      profileUserData,
      shallShowUserProfileSidebar,
      showUserProfileSidebar,

      // Active Chat Contact Details
      shallShowActiveChatContactSidebar,

      // UI
      perfectScrollbarSettings,

      // UI + SM Devices
      startConversation,
      mqShallShowLeftSidebar,

      // Add Forum
      openAddForumModal,
      maxChar,
      addForumModal,
      addForumName,
      addForumDescription,
      storeForum
    }
  },
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
